<template>
  <div class="member_container">
    <p class="title_member">{{ title }}</p>
    <el-table
      :data="members"
      max-height="300"
      border
      v-loading="loading"
      element-loading-background="transparent"
      :row-style="tableRowStyle"
      :header-cell-style="tableHeaderColor"
      align="center"
      style="width: 90%;height: 70%; margin: 10px 10px 10px 80px;">
      <el-table-column
        type="index"
        label="S/N"
        width="50">
      </el-table-column>
      <el-table-column
        label="Name"
        width="200">
        <template slot-scope="scope">
          <el-button style="color: #000;" type="text" @click="show(scope.row.user_id)">{{ scope.row.name }}</el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop="pass_no"
        label="ID/Pass No.">
      </el-table-column>
      <el-table-column
        prop="pass_type"
        label="ID/Pass Type">
      </el-table-column>
      <el-table-column
        prop="nationality"
        label="Nationality">
      </el-table-column>
      <el-table-column
        prop="designation"
        label="Designation">
      </el-table-column>
      <el-table-column
        prop="type_of_worker"
        label="Type of Worker">
      </el-table-column>
      <el-table-column
        prop="address"
        label="Address">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: "member",
  props: ['project_id', 'user_id'],
  data() {
    return {
      title: 'Project Members',
      my_user_id: this.user_id,
      members: [],
      loading: true
    }
  },
  methods: {
    // 修改table tr行的背景色
    tableRowStyle({row, rowIndex}) {
      if (rowIndex % 2 == 0) {
        return 'background-color: #F4D347'
      } else {
        return 'background-color: #FBEDB5'
      }
    },
    // 修改table header的背景色
    tableHeaderColor({row, column, rowIndex, columnIndex}) {
      if (rowIndex === 0) {
        return 'background-color: black;color: #fff;font-weight: 400'
      }
    },
    show(user_id) {
      this.my_user_id = user_id
    }
  },
  watch: {
    user_id(val) {
      this.my_user_id = val
    },
    my_user_id(val) {
      this.$emit('update:user_id', val)
    }
  },

  mounted() {
    let postData = {
      project_id: this.project_id,
      user: window.localStorage.getItem("token_key"),
      token: window.localStorage.getItem('token')
    }
    axios.post(this.$store.getters.getCmsServer + "DBProjMembers", postData).then(resp => {    //生产
      this.loading = false
      var errNo = resp.data.errno
      var errStr = resp.data.errstr
      if (errNo == "0") {
        var result = resp.data.result;
        this.members = result
      } else {
        alert(errStr)
      }
    }).catch(error => {
      this.loading = false
      alert(error)
    })
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
.member_container {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  text-align: center;
}

.title_member
  width 100%
  height 10%
  text-align left
  font-weight bold
  font-size 16px
  color #FFF
  padding-top 0
  padding-left 25px

.mc_tender_title1 {
  width: 100px;
  height: 20px;
  line-height: 20px;
  text-align: left;
  color: white;
  font-size: 12px;
  padding-left: 10px;
  margin-top 0
  float: left;
}

.mc_tender_title2 {
  width: 100px;
  height: 20px;
  line-height: 20px;
  text-align: left;
  color: white;
  font-size: 12px;
  padding-left: 10px;
  margin-top 0
  float: left;
}

.mc_tender {
  width: 100%;
  height: 30px;
  line-height: 35px;
  text-align: left;
  font-size: 14px;
  float: left;
}

.p_member_index {
  width: 100px;
  height: 30px;
  line-height: 35px;
  text-align: left;
  color: black;
  font-size: 16px;
  padding-left: 10px;
  margin-top 0
  float: left;
}

.p_member_name {
  width: 100px;
  height: 30px;
  line-height: 35px;
  text-align: left;
  color: black;
  font-size: 16px;
  padding-left: 10px;
  margin-top 0
  float: left;
}

.el-table td, .el-table th.is-leaf, .el-table--border, .el-table--group {
  border-color: black;
}

.el-table--border::after, .el-table--group::after, .el-table::before {
  background-color: black;
}

.el-table__header tr,
.el-table__header th {
  padding: 0;
  height: 20px;
  text-align center
}

.el-table__body tr,
.el-table__body td {
  padding: 0;
  height: 30px;
  text-align center
  color: #000
}

p {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/manpower/member.vue